// extracted by mini-css-extract-plugin
module.exports = {"companyCard":"companyCard_companyCard__F9hCA","cardTitle":"companyCard_cardTitle__2liJG"};